<template>
    <div class="row">
        <div class="col-12">
            <h3>
                <span>Дані страхувальника (Покупець)</span>
            </h3>
        </div>
        <div class="col-lg-12 row passport-row">
            <div class="col-lg-4">
                <div class="form-group">
                    <input
                        v-model="payer.name_ua"
                        @change="getClientDataForUpdating"
                        type="text"
                        placeholder="Ім’я"
                        v-on:keypress="LetterCyrMask"
                        :class="['form-control', { invalid: ((!$v.payer.name_ua.required && $v.payer.name_ua.$error) || (!onlyCyrCharacters(payer.name_ua) && $v.payer.name_ua.error)) }]"
                    />
                    <small class="error" v-if="!$v.payer.name_ua.required && $v.payer.name_ua.$error">Вкажіть ім’я</small>
                    <small class="error" v-if="LetterMaskError || !onlyCyrCharacters(payer.name_ua)">Тільки кирилиця</small>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group surname-block">
                    <input
                        v-model="payer.surname_ua"
                        @change="getClientDataForUpdating"
                        maxlength="30"
                        type="text"
                        v-on:keypress="LetterCyrMask"
                        placeholder="Прізвище"
                        :class="['form-control surname-field', { invalid: ((!$v.payer.surname_ua.required && $v.payer.surname_ua.$error) || (!$v.payer.surname_ua.minLength) || (!$v.payer.surname_ua.maxLength)) || ($v.payer.surname_ua.$error && !onlyCyrCharacters(payer.surname_ua)) }]"
                    />
                    <div v-if="isLoadInsuredsListBySurname" class="load-insured-list spinner-border spinner-border-sm" role="status"></div>
                    <div v-if="insuredsListBySurname['payer'] && insuredsListBySurname['payer'].length > 0" class="autocomplete-surname">
                        <div @click="selectInsuredInfo(insured, 'payer')" class="inn-items mb-1 mt-2" v-for="insured in insuredsListBySurname['payer']">
                            <insureds-list-item :insured="insured"></insureds-list-item>
                        </div>
                    </div>
                    <small class="error" v-if="!$v.payer.surname_ua.required && $v.payer.surname_ua.$error">Вкажіть прізвище</small>
                    <small class="error" v-if="LetterMaskError || !onlyCyrCharacters(payer.surname_ua)">Тільки кирилиця</small>
                    <small class="error" v-else-if="!$v.payer.surname_ua.minLength || !$v.payer.surname_ua.maxLength">Введіть коректно прізвище</small>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group">
                    <input
                        v-model="payer.patronymic_ua"
                        @change="getClientDataForUpdating"
                        type="text"
                        placeholder="По-батькові"
                        v-on:keypress="LetterCyrMask"
                        :class="['form-control', { invalid: ((!$v.payer.patronymic_ua.exists && $v.payer.patronymic_ua.$error) || (!onlyCyrCharacters(payer.patronymic_ua) && $v.payer.patronymic_ua.error)) }]"
                    />
                    <small class="error" v-if="!$v.payer.patronymic_ua.exists && $v.payer.patronymic_ua.$error">Вкажіть по-батькові</small>
                    <small class="error" v-if="LetterMaskError || !onlyCyrCharacters(payer.patronymic_ua)">Тільки кирилиця</small>
                </div>
            </div>
        </div>
        <div class="col-lg-12 row passport-row">
            <div class="col-lg-6">
                <div class="form-group tooltip-group inn-block">
                    <input
                        type="text"
                        placeholder="ІПН"
                        v-model="payer.identificationCode"
                        :disabled="payer.withoutIdentificationCode"
                        :class="['form-control inn-field', { invalid: hasError('payer.identificationCode') || (!$v.payer.identificationCode.required && $v.payer.identificationCode.$error) || (!$v.payer.identificationCode.customMinLength && $v.payer.identificationCode.$error) }]"
                        v-mask="'##########'"
                        maxlength="10"
                    />
                    <div v-if="insuredsList['payer'] && insuredsList['payer'].length > 0" class="autocomplete-inn">
                        <div @click="selectInsuredInfo(insured, 'payer')" class="inn-items mb-1 mt-2" v-for="insured in insuredsList['payer']">
                            <insureds-list-item :insured="insured"></insureds-list-item>
                        </div>
                    </div>
                    <i v-if="!isLoadInsuredsList" data-html="true" data-toggle="tooltip" data-select="true" title="" class="icon question" data-original-title="<img src='https://ukasko.ua/images/tooltips/inn.png'>"></i>
                    <div v-else class="load-insured-list spinner-border spinner-border-sm" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <small class="error" v-if="!$v.payer.identificationCode.required && $v.payer.identificationCode.$error">Введіть ІПН</small>
                    <small class="error" v-else-if="!$v.payer.identificationCode.customMinLength && $v.payer.identificationCode.$error">Введіть коректно ІПН</small>
                    <small class="error" v-else-if="!payer.withoutIdentificationCode && hasError('payer.identificationCode')">{{ errors['payer.identificationCode'][0] }}</small>
                    <small>
                        <div class="form-check">
                            <input v-model="payer.withoutIdentificationCode" @click="disableIdentificationCode" type="checkbox" class="form-check-input" id="withoutIdentificationCode" />
                            <label class="form-check-label" for="withoutIdentificationCode">Відсутній ІПН</label>
                        </div>
                    </small>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <input
                        v-mask="'##.##.####'"
                        placeholder="Дата народження"
                        @change="getClientDataForUpdating"
                        v-model="payer.dateBirth"
                        :class="['form-control', 'form-input_date', { invalid: ((!$v.payer.dateBirth.required && $v.payer.dateBirth.$error) || (!$v.payer.dateBirth.customMinLength && $v.payer.dateBirth.$error) || errorBirthDate()) }]"
                    />
                    <small class="error" v-if="!$v.payer.dateBirth.required && $v.payer.dateBirth.$error">Введіть дату народження</small>
                    <small class="error" v-else-if="(!$v.payer.dateBirth.customMinLength || !$v.payer.dateBirth.daysInMonth) && $v.payer.dateBirth.$error">Введіть коректну дату народження</small>
                    <small class="invalid-feedback error" v-else-if="hasError('payer.errorBirthDate')" v-html="getError('payer.errorBirthDate')"></small>
                    <small class="error" v-else-if="errorTaxNumber()">
                        <small class="error" v-if="hasError('payer.errorBirthDate')">{{ errors['payer.errorBirthDate'][0] }}</small>
                    </small>
                </div>
            </div>
        </div>
        <div class="col-lg-12 row passport-row">
            <div class="col-lg-6">
                <div class="form-group">
                    <input
                        v-model.trim="payer.mail"
                        @change="getClientDataForUpdating"
                        type="text"
                        placeholder="Ел. пошта"
                        :class="['form-control', { invalid: (!$v.payer.mail.required && $v.payer.mail.$error) || (!$v.payer.mail.email && $v.payer.mail.$error) }]"
                    />
                    <small class="error" v-if="!$v.payer.mail.required && $v.payer.mail.$error">Вкажіть пошту</small>
                    <small class="error" v-else-if="!$v.payer.mail.email && $v.payer.mail.$error">Введіть коректно пошту</small>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <input
                        v-model.trim="payer.phone"
                        @change="getClientDataForUpdating"
                        v-mask="'+38 (0##) ###-##-##'"
                        type="text"
                        placeholder="Телефон"
                        :class="['form-control', { invalid: (!$v.payer.phone.required && $v.payer.phone.$error) }]"
                    />
                    <small class="error" v-if="!$v.payer.phone.required && $v.payer.phone.$error">Вкажіть телефон</small>
                    <small class="error" v-else-if="!$v.payer.phone.minLength">Введіть номер в форматі 380xxxxxxxx</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { email, maxLength, minLength, required, requiredIf } from 'vuelidate/lib/validators';
import InsuredsListItem from "@/views/osago/components/InsuredsListItem.vue";
import { getData } from "@/api/client";
import moment from 'moment';

export default {
    components: { InsuredsListItem },
    props: ['payer'],

    data() {
        return {
            LetterMaskCyrError: false,
            LetterMaskError: false,
            errors: {},
            insuredsList: {},
            isLoadInsuredsList: false,
            isLoadInsuredsListBySurname: false,
            insuredsListBySurname: {},
            timer: null,
            fetchClientsTimeout: null,
            isfillData: false,
        };
    },

    model: {
        prop: 'payer',
        event: 'input',
    },

    validations: {
        payer: {
            identificationCode: {
                required: requiredIf(function () {
                    return !this.payer.withoutIdentificationCode;
                }),
                customMinLength(value) {
                    if (this.payer.withoutIdentificationCode && (value === null || value === undefined || value === '')) {
                        return true;
                    }
                    return value !== undefined && value !== null && value.length === 10;
                }
            },
            name_ua: {
                required,
                minLength: minLength(2),
                maxLength: maxLength(30),
                cyrillic: function(value) {
                    return this.onlyCyrAndNumAndSpecials(value);
                }
            },
            surname_ua: {
                required: requiredIf(() => true),
                minLength: minLength(2),
                maxLength: maxLength(30),
                cyrillic: function(value) {
                    return this.onlyCyrAndNumAndSpecials(value);
                }
            },
            patronymic_ua: {
                required,
                minLength: minLength(2),
                maxLength: maxLength(30),
                cyrillic: function(value) {
                    return this.onlyCyrAndNumAndSpecials(value);
                }
            },
            dateBirth: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(10),
                customMinLength(value) {
                    return value !== null && value.length === 10;
                },
                daysInMonth: function (value) {
                    if (value === null) {
                        return true;
                    }
                    return parseInt(moment(value, 'DD.MM.YYYY').format('DD')) <= moment(value, 'DD.MM.YYYY').daysInMonth();
                }
            },
            phone: { required, minLength: minLength(19) },
            mail: { required, email },
        },
    },

    created() {
        if (this.payer.surname_ua) {
            this.isLoadInsuredsList = true;
            this.fetchClients(this.payer.surname_ua, 'surname');
        }

        if (this.payer.identificationCode) {
            this.isLoadInsuredsList = true;
            this.fetchClients(this.payer.identificationCode, 'identificationCode');
        }
    },

    computed: {
        searchInfo() {
            return this.$store.getters.HOME_SEARCH_PARAMS;
        },

        offerInfo() {
            return this.$store.getters.HOME_INFO_OFFER;
        },
    },

    watch: {
        'payer.surname_ua': function (newValue) {
            if(this.isfillData === true) return;

            if (newValue && newValue.length >= 3) {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    this.isLoadInsuredsListBySurname = true;
                    await this.fetchClients(newValue, 'surname');
                }, 800);
            } else {
                this.insuredsListBySurname['payer'] = [];
                this.isLoadInsuredsListBySurname = false;
            }
        },

        'payer.name_ua': async function(newValue, oldValue) {
            this.insuredsListBySurname['payer'] = [];
            this.isLoadInsuredsByCompanyName = false;
        },

        'payer.dateBirth': function() {
            delete this.errors['payer.dateBirth'];
            delete this.errors['payer.identificationCode'];
            delete this.errors['payer.errorBirthDate'];
        },

        'payer.identificationCode': function(newValue) {
            if(this.isfillData === true) return;
            if (newValue && newValue.length >= 2) {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    if (newValue && newValue.length === 10) {
                        this.payer.dateBirth = moment('01.01.1900', 'DD.MM.YYYY')
                            .add(newValue.substr(0, 5) - 1, 'day')
                            .format('DD.MM.YYYY');
                    }
                    this.isLoadInsuredsList = true;
                    await this.fetchClients(newValue, 'identificationCode');
                }, 800);
            }

            delete this.errors['payer.identificationCode'];
        },

        'payer': {
            handler: function () {
                this.$store.commit('SET_HOME_INFO_USER', this.payer);
            },
            deep: true
        },
    },

    methods: {
        onlyCyrAndNumAndSpecials(str) {
            if(str == null || str == "") return true;

            return /^[А-Яа-яЇїІіҐґ+'ʼ"Єє`0-9\-.\/ ]+$/.test(str);
        },

        async fetchClients(query, type) {
            if (!query) {
                this.isLoadInsuredsList = false;
                return;
            }

            if (type === "identificationCode") {
                this.insuredsList = {};
            } else if (type === "surname") {
                this.insuredsListBySurname = {};
            }

            const params = {
                "requestType": "clientsByUserId",
                "searchText": query,
                "customerType": this.orderData?.requestData?.customerType
            };

            if (this.fetchClientsTimeout) {
                clearTimeout(this.fetchClientsTimeout);
            }

            this.fetchClientsTimeout = setTimeout(async () => {
                try {
                    let response = await getData(params);
                    if (type == "identificationCode") {
                        this.insuredsList['payer'] = response.data.data.items;
                        this.isLoadInsuredsList = false;
                    } else if (type == "surname") {
                        this.insuredsListBySurname['payer'] = response.data.data.items;
                        this.isLoadInsuredsListBySurname = false;
                    }
                } catch (error) {
                    console.error("Error fetching clients:", error);
                    this.isLoadInsuredsList = false;
                    this.isLoadInsuredsListBySurname = false;
                }
            }, 1000);
        },

        getClientDataForUpdating() {
            this.$emit('getClientDataForUpdating');
        },

        onlyLatinCharacters(str) {
            if (str == null || str == "") return true;
            return /^[a-zA-Z\- ]+$/.test(str);
        },

        validateTaxNumber(tax_number, date) {
            if (!tax_number || !date || tax_number.length !== 10 || date.length !== 10) {
                return false;
            }

            let birthDate = moment(date, 'DD.MM.YYYY');
            if (!birthDate.isValid()) {
                return false;
            }

            let tax_numberDate = moment('01.01.1900', 'DD.MM.YYYY').add(tax_number.substr(0, 5) - 1, 'day');
            return tax_numberDate.isSame(birthDate, 'year') && tax_numberDate.isSame(birthDate, 'month') && tax_numberDate.isSame(birthDate, 'day');
        },

        errorTaxNumber() {
            if (this.payer.withoutIdentificationCode) {
                return false;
            }

            if (!this.payer.identificationCode || !this.payer.dateBirth) {
                return false;
            }

            if (this.payer.dateBirth.length === 10 && this.payer.identificationCode.length === 10 && !this.validateTaxNumber(this.payer.identificationCode, this.payer.dateBirth)) {
                this.errors['payer.identificationCode'] = ["ІПН та Дата народження не співпадають"];
                return true;
            }

            return false;
        },

        errorBirthDate() {
            if (!this.payer.dateBirth) {
                return false;
            }

            const birthDate = moment(this.payer.dateBirth, 'DD.MM.YYYY');
            if (!birthDate.isValid()) {
                return true;
            }

            if (birthDate.isAfter(moment())) {
                this.errors['payer.errorBirthDate'] = ["Дата народження не може бути в майбутньому"];
                return true;
            }

            const age = moment().diff(birthDate, 'years');

            if (age < 18) {
                this.errors['payer.errorBirthDate'] = ["Страхувальнику повинно бути більше 18 років"];
                return true;
            } else if (age > 100) {
                this.errors['payer.errorBirthDate'] = ["Страхувальнику повинно бути не більше 100 років"];
                return true;
            }

            return false;
        },

        getError(name) {
            if (this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }
            return "";
        },

        LetterCyrMask(e) {
            let char = String.fromCharCode(e.keyCode);
            if(/^[А-Яа-яЇїІіҐґ+'ʼЄє` ]+$/.test(char)) {
                this.LetterMaskError = false;
                return true;
            } else {
                this.LetterMaskError = true;
                e.preventDefault();
            }
        },

        onlyLatinCharactersAndNum(str) {
            if (str == null || str == "") return true;
            return /^[a-zA-Z0-9 ]+$/.test(str);
        },

        onlyCyrCharacters(str) {
            if(str == null || str == "") return true;
            return /^[А-Яа-яЇїІіҐґ'ʼЄєщЩ`\- ]+$/.test(str);
        },

        selectInsuredInfo(insured) {
            this.$emit('selectInsuredInfo', insured);
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },

        disableIdentificationCode() {
            this.payer.identificationCode = '';
            delete this.errors['payer.identificationCode'];
        },
    },
}
</script>
